module.exports = __webpack_public_path__ + "media/images/banners/MyMP-Banner-ec03398777236c292d2ed1e3cb20f742.png";